import React, { useMemo, memo } from "react";
import useData from "../../../../hooks/use-data";
import { ApiPaths } from "../../../../api/paths";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../../../context/app-context";

interface Props {
  email: string;
}

function ProfilePic({ email }: Props) {
  const { t } = useTranslation(["myProfile"]);
  const { user, userProfilePic } = useAppContext();

  if (user?.email === email) {
    return (
      <div>
        <img
          src={
            userProfilePic?.photo ||
            process.env.PUBLIC_URL + "/assets/icons/profile1.png"
          }
          alt="Profile Image"
          className="profileImg img-fluid"
        />
      </div>
    );
  }

  const profileParams = useMemo(
    () => ({
      params: {
        search: email,
      },
    }),
    [email]
  );

  const { data } = useData<any>(`${ApiPaths.profilePicture}`, {
    options: profileParams,
    onError: () => {
      toast(t("mutate_Profile.error.fetch_single", { ns: "myProfile" }), {
        type: "error",
      });
    },
    fetchIf: user?.email !== email,
  });

  return (
    <div>
      <img
        src={
          data?.photo || process.env.PUBLIC_URL + "/assets/icons/profile1.png"
        }
        alt="Profile Image"
        className="profileImg img-fluid"
      />
    </div>
  );
}

export default memo(ProfilePic);
